import { BasketState } from 'store/basket/basketReducer';

// 86400000 ms = 1 day
// 3600000 ms = 1 hour
const STORAGE_EXPIRATION = 3 * 3600000;

export const updateLocalBasket = (basket: BasketState) => {
    localStorage.setItem('basket', JSON.stringify(basket));
    localStorage.setItem('basket_expiration', (Date.now() + STORAGE_EXPIRATION).toString());
};

export const resetLocalBasket = () => {
    localStorage.removeItem('basket');
    localStorage.removeItem('basket_expiration');
};

export const partialResetLocalBasket = () => {
    const localBasket = getLocalBasket();
    localStorage.setItem(
        'basket',
        JSON.stringify({
            deliveryLocation: localBasket?.deliveryLocation,
            checkId: localBasket?.checkId,
            locationId: localBasket?.locationId
        })
    );
    localStorage.setItem('basket_expiration', (Date.now() + STORAGE_EXPIRATION).toString());
};

export const getLocalBasket = (): BasketState | null => {
    const basketString = localStorage.getItem('basket');
    const expiration = localStorage.getItem('basket_expiration');
    if (!basketString || !expiration || Date.now() - parseInt(expiration, 10) > STORAGE_EXPIRATION) {
        resetLocalBasket();
        return null;
    }
    return JSON.parse(basketString);
};
